module.exports = __webpack_public_path__ + "media/entities/2003-4d92c57f.png";